import { Currencies } from './currencies';

export const getCurrencySymbol = (currencyCode: string) => {
  for (let i = 0; i < Currencies.length; i++) {
    if (Currencies[i].code === currencyCode) return Currencies[i].symbol;
  }
};
